module.exports = function() {
  return new Worker(__webpack_public_path__ + "5782213860966d344324.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
// module id = 978
// module chunks = 169